module.exports = __webpack_public_path__ + "img/rocketprint-logo.f909c305.png";